import { render, staticRenderFns } from "./SimpleButtonCta.vue?vue&type=template&id=0fe0d498"
import script from "./SimpleButtonCta.vue?vue&type=script&lang=js"
export * from "./SimpleButtonCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports